let el
let subitemToggles
let actions
let subcontainers
let primaryNav
let navBtn
let overlay
let toTopBtn

const mobileMedia = '(max-width: 999px)'

export function RFHeader() {
    el = document.querySelector('.js-header')
    if (!el) {
        return
    }

    subitemToggles = el.querySelectorAll('.js-header-subitems-toggle')
    subitemToggles = Array.from(subitemToggles)

    actions = el.querySelectorAll('.js-header-action')
    actions = Array.from(actions)

    subcontainers = el.querySelectorAll('.js-header-subcontainer > *')
    subcontainers = Array.from(subcontainers)

    primaryNav = el.querySelector('.js-header-primary-nav')

    navBtn = el.querySelector('.js-header-mobile-btn')

    overlay = document.querySelector('.js-header-overlay')

    toTopBtn = document.querySelector('.js-header-top-btn')

    el.addEventListener('click', (evt) => {
        if (evt.target.classList.contains('js-header-subitems-toggle')) {
            handleSubitemToggle(evt.target)
        }

        if (evt.target.classList.contains('js-header-action')) {
            handleActionToggle(evt.target)
        }
    })

    navBtn.addEventListener('click', toggleMobileNav)

    overlay.addEventListener('click', () => {
        handleSubitemToggle(false)
    })

    window.addEventListener('scroll', updateTopBtn, {
        passive: true
    })
    updateTopBtn()
}

function updateTopBtn() {
    const currentScroll = window.scrollY

    if (currentScroll > 250 && toTopBtn.classList.contains('is-hidden')) {
        toTopBtn.classList.remove('is-hidden')
    } else if (currentScroll <= 250 && !toTopBtn.classList.contains('is-hidden')) {
        toTopBtn.classList.add('is-hidden')
    }
}

function handleSubitemToggle(toggle) {
    let isOpening = false
    let isMobile = window.matchMedia(mobileMedia).matches

    if (!isMobile) {
        subitemToggles.forEach((el) => {
            if (el == toggle && el.getAttribute('aria-expanded') === 'false') {
                el.setAttribute('aria-expanded', 'true')
                isOpening = true
            } else {
                el.setAttribute('aria-expanded', 'false')
            }
        })

        if (el.classList.contains('is-active') && !isOpening) {
            el.classList.remove('is-active')
        } else if (!el.classList.contains('is-active') && isOpening) {
            el.classList.add('is-active')
        }
    }

    actions.forEach((el) => {
        el.setAttribute('aria-expanded', 'false')
    })

    subcontainers.forEach((el) => {
        el.classList.remove('is-active')
    })
}

function handleActionToggle(toggle) {
    const targetId = toggle.getAttribute('aria-controls')
    let isOpening = false
    let isMobile = window.matchMedia(mobileMedia).matches

    subitemToggles.forEach((el) => {
        el.setAttribute('aria-expanded', 'false')
    })

    actions.forEach((el) => {
        if (el == toggle && el.getAttribute('aria-expanded') === 'false') {
            el.setAttribute('aria-expanded', 'true')
            isOpening = true
        } else {
            el.setAttribute('aria-expanded', 'false')
        }
    })

    subcontainers.forEach((el) => {
        if (el.id === targetId && !el.classList.contains('is-active')) {
            el.classList.add('is-active')
        } else {
            el.classList.remove('is-active')
        }
    })

    if (isOpening && !el.classList.contains('is-active')) {
        el.classList.add('is-active')
        if (isMobile) {
            document.body.dataset.lock = true
        }
    }

    if (!isOpening) {
        el.classList.remove('is-active')
        if (isMobile) {
            document.body.removeAttribute('data-lock')
        }
    }

    if (isMobile) {
        if (primaryNav.classList.contains('is-active')) {
            primaryNav.classList.remove('is-active')
            navBtn.setAttribute('aria-expanded', 'false')
        }
    }
}

function toggleMobileNav() {
    if (primaryNav.classList.contains('is-active')) {
        el.classList.remove('is-active')
        primaryNav.classList.remove('is-active')
        document.body.removeAttribute('data-lock')
        navBtn.setAttribute('aria-expanded', 'false')
    } else {
        el.classList.add('is-active')
        primaryNav.classList.add('is-active')
        document.body.dataset.lock = true
        navBtn.setAttribute('aria-expanded', 'true')
    }

    subitemToggles.forEach((el) => {
        el.setAttribute('aria-expanded', 'false')
    })

    actions.forEach((el) => {
        el.setAttribute('aria-expanded', 'false')
    })

    subcontainers.forEach((el) => {
        el.classList.remove('is-active')
    })
}
